export default function openWhatsApp(matches, whatsAppNumber) {
  if (matches) {
    window.open(`https://wa.me/${whatsAppNumber}?`, "_blank");
  } else {
    window.open(
      `https://web.whatsapp.com/send?phone=${whatsAppNumber}`,
      "_blank"
    );
  }
}
